import React, {useState} from 'react';
import {getNoun} from "../utils";

function AdvCardItem({
                             imgSource,
                             imgAlt,
                             imgTitle,
                             badgeText,
                             badgeClass,
                             loanAmount,
                             cardText,
                             offerLink,
                             webmasterId,
                            offerPosition
                         }) {

    const randomLoans = () => {
        const loans = Math.round(Math.round(Math.random() * 100) * 4.2)
        const noun = getNoun(loans, ' займ ', ' займа ', ' займов ')
        return `${loans}${noun}`
    }
    return (
        <a href={`${offerLink}?pos=${offerPosition}`} target={'_blank'} rel={'noreferrer'}>
            <div className="card mb-3 shadow">
                <img
                    src={imgSource}
                    className="card-img-top"
                    alt={imgAlt}
                    title={imgTitle}
                />
                <div className="card-body flat-card-body">
                    <div className="d-flex justify-content-between mb-2">
                    <span className={`${badgeClass} py-2`}>
                        {badgeText}
                    </span>
                    </div>
                    <h5 className="card-title mt-3">{loanAmount}</h5>
                    <p className="card-text text-black">
                        {cardText}
                    </p>

                    <ul className="list-inline mb-3">
                        <li className="list-inline-item me-0 ">
                            <i className="fas fa-star text-warning"/>
                        </li>
                        <li className="list-inline-item me-0 ">
                            <i className="fas fa-star text-warning"/>
                        </li>
                        <li className="list-inline-item me-0 ">
                            <i className="fas fa-star text-warning"/>
                        </li>
                        <li className="list-inline-item me-0 ">
                            <i className="fas fa-star text-warning"/>
                        </li>
                        {(Math.round(Math.random() * 10) % 3) >= 1
                            ?
                            <li className="list-inline-item me-0 ">
                                <i className="fas fa-star text-warning"/>
                            </li>
                            :
                            <li className="list-inline-item me-0 ">
                                <i className="fas fa-star-half-alt text-warning"/>
                            </li>
                        }
                    </ul>

                    <div className="card-footer pt-0 pb-3" style={{marginRight: '-11px', marginLeft: '-15px'}}>
                        <hr/>
                        <div className="d-flex justify-content-between">
                            <span className="h6 fw-light mb-0" style={{fontSize: '14px'}}>
                                <i className="far fa-regular fa-thumbs-up text-danger me-2"/>
                                {randomLoans()} одобрили сегодня
                            </span>
                        </div>
                    </div>

                    <button className="btn btn-lg btn-danger-soft form-control">
                        Получить деньги
                    </button>
                </div>


            </div>
        </a>
    )
}

export default AdvCardItem